const subscriptionEn = {
    subscription: require('../../lang/en/subscription/Subscription').default,
};

export default subscriptionEn;
